import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { BaseModel } from '../../types/generated.types';

@Injectable({ providedIn: 'root' })
export class BillingGroupsApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/billing-groups`;
  }

  async getBillingGroups(): Promise<BaseModel[]> {
    return await this.get<BaseModel[]>('');
  }

  async createBillingGroup(billingGroup: BaseModel): Promise<void> {
    return await this.post<BaseModel>('', billingGroup);
  }

  async updateBillingGroup(billingGroup: BaseModel): Promise<void> {
    return await this.put('', billingGroup);
  }

  async deleteBillingGroup(billingGroup: BaseModel): Promise<void> {
    return await this.delete(`${billingGroup.id}`);
  }
}
